import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon } from '@react-email/editor/ui';
import { Tooltip } from '@mantine/core';

interface Props {
	value: string;
	onChange: (value: string) => void;
}

export const AlignRow = ({ value, onChange }: Props) => {
	const tMipManage = useTranslationMipManage();

	const options = [
		{
			value: 'left',
			label: tMipManage('email_templates.editor.inspector.align_left', {
				defaultValue: 'Left',
			}),
			Icon: AlignLeftIcon,
		},
		{
			value: 'center',
			label: tMipManage('email_templates.editor.inspector.align_center', {
				defaultValue: 'Center',
			}),
			Icon: AlignCenterIcon,
		},
		{
			value: 'right',
			label: tMipManage('email_templates.editor.inspector.align_right', {
				defaultValue: 'Right',
			}),
			Icon: AlignRightIcon,
		},
	];

	return (
		<div data-re-inspector-prop-row="">
			<label data-re-inspector-label="">
				{tMipManage('email_templates.editor.inspector.align', { defaultValue: 'Align' })}
			</label>
			<div data-re-inspector-toggle-group="" role="group">
				{options.map((option) => (
					<Tooltip key={option.value} label={option.label} withArrow>
						<button
							type="button"
							data-re-inspector-toggle-item=""
							data-active={value === option.value ? '' : undefined}
							aria-pressed={value === option.value}
							aria-label={option.label}
							onClick={() => onChange(option.value)}
						>
							<option.Icon width={16} height={16} />
						</button>
					</Tooltip>
				))}
			</div>
		</div>
	);
};
